import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResultColumnsService {

  cols: any[];
  fixedcolumns: any[];

  private selectedColsSubject = new BehaviorSubject<any[]>([]);
  public selectedCols$ = this.selectedColsSubject.asObservable();

  constructor() {
    this.cols = [
      { field: 'DocumentTitle', header: 'Document Title', sortField: "document.DocumentTitle" },
      { field: 'DocumentType', header: 'Doc Type', sortField: "document.DocumentType" },
      { field: 'DocumentDate', header: 'Doc Date', sortField: "document.DocumentDate" },
      { field: 'AuthorName', header: 'Author(s)', sortField: "document.AuthorName" },// AuthorName: string[];
      { field: 'AuthorAffiliation', header: 'Author Affiliation', sortField: "document.AuthorAffiliation" },// AuthorAffiliation: string[];
      { field: 'AddresseeName', header: 'Addressee Name', sortField: "document.AddresseeName" },// AddresseeName: string[];
      { field: 'AddresseeAffiliation', header: 'Addressee Affiliation', sortField: "document.AddresseeAffiliation" },// AddresseeAffiliation: string[];
      { field: 'CaseReferenceNumber', header: 'Case Ref. #', sortField: "document.CaseReferenceNumber" },// CaseReferenceNumber: string[];
      { field: 'Comment', header: 'Comment', sortField: "document.Comment" },
      { field: 'ContactPerson', header: 'Contact', sortField: "document.ContactPerson" },// ContactPerson?: string;
      // { field: 'DateAdded', header: 'Date Added', sortField: "document.DateAdded" },
      { field: 'DateAddedTimestamp', header: 'Date Added (EST)', sortField: "document.DateAddedTimestamp" },
      { field: 'DocumentReportNumber', header: 'Doc. Rep. #', sortField: "document.DocumentReportNumber" },// DocumentReportNumber: string[];
      { field: 'DocketNumber', header: 'Docket #', sortField: "document.DocketNumber" },// DocketNumber: string[];
      { field: 'DistributionListCodes', header: 'Dist. List Codes', sortField: "document.DistributionListCodes" },// DistributionListCodes?: string;
      { field: 'EstimatedPageCount', header: 'Estimated Pages', sortField: "document.EstimatedPageCount" },// EstimatedPageCount?: string;
      { field: 'Keyword', header: 'Keyword', sortField: "document.Keyword" },
      { field: 'LicenseNumber', header: 'License #', sortField: "document.LicenseNumber" },// LicenseNumber: string[];
      // { field: 'PackageNumber', header: 'Package #', sortField: "document.PackageNumber" },
      { field: 'PackagesFiledIn', header: 'Package #', sortField: "document.PackagesFiledIn" },
      { field: 'DocumentsFiledInPackage', header: 'Docs In Package', sortField: "document.DocumentsFiledInPackage" },
      { field: 'MicroformAddresses', header: 'Microform Addresses', sortField: "document.MicroformAddresses" },
      { field: 'PhysicalFileLocation', header: 'Physical Location', sortField: "document.PhysicalFileLocation" },
      { field: 'DocumentSize', header: 'Document Size', sortField: "document.DocumentSize" },
    ];

    this.fixedcolumns = [{ field: 'AccessionNumber', header: 'Accession Number', sortField: "document.AccessionNumber" },
    { field: 'DocumentTitle', header: 'Document Title', sortField: "document.DocumentTitle" },
    // { field: 'DateAdded', header: 'Date Added', sortField: "document.DateAdded" },
    { field: 'DateAddedTimestamp', header: 'Date Added TS', sortField: "document.DateAddedTimestamp" },
    { field: 'DocumentDate', header: 'Doc Date', sortField: "document.DocumentDate" },
    { field: 'DocumentSize', header: 'Document Size', sortField: "document.DocumentSize" },
    ];
  }
  
  setSelectedCols(cols: any[]) {
    this.selectedColsSubject.next(cols);
  }

  getSelectedCols(): any[] {
    return this.selectedColsSubject.value;
  }

  parseSelectedCols(tableCols: any) {
    let selectedCols: any[] = [];
    let tc = tableCols;
    if (typeof (tc) == 'string') {
      tc = JSON.parse(tc);
    }

    tc.forEach((colItem: string) => {
      let sc = this.cols.find((c) => c["field"] == colItem);

      if (sc) {
        //Avoid adding duplicates...
        if (selectedCols.length > 0) {
          let exists = selectedCols.find((item) => item["field"] == sc["field"]);
          if (!exists) {
            selectedCols.push(sc);
          }
        }
        else {
          selectedCols.push(sc);
        }
      }
    });

    this.setSelectedCols(selectedCols);
  }
}
